import { ColDef } from '@ag-grid-community/core'
import { NfGridOptions } from '@northfork/ag-grid'

/**
 * Ag Grid's select all cell renderer text value
 */
export const SELECT_ALL = '(Select All)'

export const heliosDefaultColWidth = {
  SerialNumberCol: 40,
  ValidityStatusCol: 30,
  SmallIcon: 36,
  MediumIcon: 48,
  LargeIcon: 56,
  Id: 78,
  DateCol: 106,
  DateTime: 186,
  SecurityIdentifier: 106,
  Default: 120,
}

/** Default column definition commonly used in Helios. */
export const heliosDefaultColDef: ColDef = {
  ...(NfGridOptions.defaultColDef ?? {}),
  cellRenderer: undefined,
  filterParams: {
    buttons: ['apply', 'reset'],
    closeOnApply: true,
  },
  sortable: true,
  width: heliosDefaultColWidth.Default,
}
